/**
 *
 * Asynchronously loads the component for TableLoader
 *
 */

import { lazyLoad } from 'utils/loadable';

export const TableLoader = lazyLoad(
  () => import('./index'),
  module => module.TableLoader,
);
